<template>
  <footer class="footer flex flex-wrap justify-between items-center bg-brand border-b border-section_border px-3">
    <div class="text-white font-semibold text-lg pl-1">
      お知らせ
    </div>
    <div v-if="getUnreadCount() > 0" class="absolute right-1 mt-1 top-0 menuIcon w-5 text-center text-sm text-white">
        {{getUnreadCount()}}
      </div>
    <div class="float-right bg-brand h-full text-white py-3 text-base" @click="openNews">
      表示する＞
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      notice: 'notice/getAll',
      alreadyRead: 'notice/getAlreadyRead'
    }),
  },
  methods: {
    openNews: function () {
      //お知らせ開く
      this.$router.push( {name: 'news', params: { lang: this.lang } })
    },
    getUnreadCount: function () {
      return this.notice.length - this.notice.filter(n => this.alreadyRead.includes(n.id)).length
    }
  }
}
</script>

<style lang="scss" scoped>
.menuIcon {
  border-radius: 50%;
  background-color: rgb(239 68 68);
}
</style>
